<template>
  <PolicyLayout :page="page" />
</template>

<script>
import PolicyLayout from "./PolicyLayout.vue";
import { loadSiteContent } from "@/services/siteContent";

export default {
  components: { PolicyLayout },
  data() {
    return {
      page: {
        eyebrow: "退款与退回政策",
        title: "退款与退回政策",
        lead: "本页面说明退款政策、PizzaKing 钱包、数字饰品和取回服务相关事项。",
        sourceLabel: "PizzaKing 版本 · 2026",
        sections: [
          {
            title: "钱包余额",
            text:
              "充值到 pizzaking 钱包的额度是用于站内功能的平台余额，不属于现实货币，也不作为现金等价物处理。",
          },
          {
            title: "数字饰品结果",
            text:
              "打开箱子、箱子战斗或升级结果经后台确认后，将作为数字服务结果记录。",
          },
          {
            title: "未使用服务",
            text:
              "如果用户尚未使用付费服务，退款处理将取决于支付渠道、账号状态和平台审核结果。",
          },
          {
            title: "发货问题",
            text:
              "真实饰品发货接口尚未确定。发货争议应在选定并接入发货平台后，按对应平台规则进行审核。",
          },
          {
            title: "界面错误",
            text:
              "视觉异常、延迟刷新或界面显示错误不会改变后台已经确认的结果。",
          },
          {
            title: "异常活动",
            text:
              "存在异常支付、多账号、风控或滥用行为的账号，可能需要额外审核后才能继续钱包或发货操作。",
          },
        ],
      },
    };
  },
  mounted() {
    loadSiteContent(this.$axios).then((content) => {
      this.page = content.refund;
    });
  },
};
</script>
